import React, { useState } from "react";
import Lightbox from "../components/Lightbox";
import { img } from "../components/Data";
import { SchedulePost } from "../components/btn/SchedulePost";

const Gallery = () => {
  const [images, setImages] = useState(img);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null); // State to handle the lightbox image

  // Function to load 9 more images
  const loadMoreImages = () => {
    setIsLoading(true);
    setTimeout(() => {
      const moreImages = Array.from({ length: 9 }, (_, index) => ({
        id: images.length + index + 1,
        url: `https://picsum.photos/300/200?random=${
          images.length + index + 1
        }`,
        text: `Image ${images.length + index + 1}`,
      }));
      setImages((prevImages) => [...prevImages, ...moreImages]);
      setIsLoading(false);
    }, 1000); // Simulate loading delay
  };

  // Handle image click to open the lightbox
  const openLightbox = (image) => {
    setSelectedImage(image);
  };

  // Handle closing the lightbox
  const closeModal = () => {
    setSelectedImage(null);
  };

  // Handle navigating between images in the lightbox
  const navigateImage = (direction) => {
    const currentIndex = images.findIndex((img) => img.id === selectedImage.id);
    let newIndex;

    if (direction === "next") {
      newIndex = (currentIndex + 1) % images.length; // Go to the next image, loop back to start
    } else if (direction === "prev") {
      newIndex = (currentIndex - 1 + images.length) % images.length; // Go to the previous image, loop back to end
    }

    setSelectedImage(images[newIndex]);
  };

  return (
    <div className="bg-white">
      {/* Gallery Grid */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {images.map((image, index) => (
          <div
            key={image.id}
            className={`relative flex flex-col items-center cursor-pointer ${
              index === images.length - 1 ? "lg:col-start-2" : ""
            }`} // Center last image in the middle
            onClick={() => openLightbox(image)} // Open the lightbox on image click
          >
            <img
              src={image.url}
              alt={image.text}
              className="w-full mx-auto object-cover text-center"
            />
            <div className=""> {/* Ensure the parent has relative positioning */}
              <p className="w-full bg-black absolute left-1/2 -translate-x-1/2 bottom-0 py-2 px-2.5 text-xs font-bold bg-opacity-90 text-center text-white">
                {image.text}
              </p>
            </div>

          </div>
        ))}

      </div>
     
      <div className="relative flex flex-col mt-5 justify-center z-10  md:bg-gradient-to-b from-transparent via-white to-white ">
      <SchedulePost /> {/* Button component */}
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <Lightbox
          image={selectedImage}
          closeModal={closeModal}
          images={images}
          navigateImage={navigateImage} // Pass navigateImage function
        />
      )}
    </div>
  );
};

export default Gallery;
